import React from 'react'
import ModalForm from '../common/modal-form'
import InputFill from '../form/InputFill'
import Button from '../elements/Button'
import RestaurantLogo from '../elements/RestaurantLogo'
import { Link } from 'react-router-dom'

import { useTranslation } from 'react-i18next'
import paths from '../../routes/paths'
import DynamicAction from '../common/dynamic-action'

const Login = ({
    isOpen,
    onClose,
    form,
    errors,
    handleInputChange,
    clearErrorField,
    handleSubmit,
    setShowAccountModal,
    setShowForgotPassword,
}) => {
    const { t } = useTranslation()

    const handleShowRegister = () => {
        onClose()
        setShowAccountModal(true)
    }

    const handleShowForgotPassword = () => {
        onClose()
        setShowForgotPassword(true)
    }

    return (
        <ModalForm
            isOpen={isOpen}
            onClose={onClose}
            centered
            rootClass="modal-login"
            contentClass="text-center"
        >
            <form onSubmit={handleSubmit}>
                <RestaurantLogo
                    className="logo-restaurant mt-6"
                    width="120px"
                />

                <InputFill
                    className="mt-6"
                    name={'username'}
                    value={form.username}
                    error={errors.username}
                    onChange={handleInputChange}
                    i18nDataError={{ minLength: 6 }}
                    onFocus={() => clearErrorField('username')}
                    placeholder={t('customerInfo.username')}
                />

                <InputFill
                    className="mt-6"
                    name={'password'}
                    value={form.password}
                    error={errors.password}
                    onChange={handleInputChange}
                    i18nDataError={{ minLength: 6 }}
                    onFocus={() => clearErrorField('password')}
                    type="password"
                    placeholder={t('customerInfo.password')}
                />

                <Button fullWidth onClick={handleSubmit} className="mt-6">
                    {t('button.login')}
                </Button>
            </form>

            <div className="mt-6 flex-center label-2">
                <DynamicAction
                    mobileProps={{
                        tag: Link,
                        onClick: onClose,
                        to: paths.forgotPassword,
                    }}
                    desktopProps={{
                        onClick: handleShowForgotPassword,
                    }}
                    className="pointer"
                >
                    {t('button.forgotPassword')}?
                </DynamicAction>
                <DynamicAction
                    mobileProps={{
                        tag: Link,
                        onClick: onClose,
                        to: paths.register,
                    }}
                    desktopProps={{
                        onClick: handleShowRegister,
                    }}
                    className="ml-6 pointer"
                >
                    {t('button.register')}
                </DynamicAction>
            </div>
        </ModalForm>
    )
}

export default Login
